module.exports = __webpack_public_path__ + "img/58.417fcbe9.png";